import styles from './ResultCounts.module.css'

export interface ResultCountsProps {
  showing: number
  total: number | null
}

/**
 * "Showing X of Y results", omitting the total when it is unknown.
 */
export function ResultCounts({ showing, total }: ResultCountsProps) {
  const shownTotal = total === null ? 0 : Math.max(total, showing)
  return (
    <span className={styles.root}>
      Showing <strong className={styles.value}>{showing}</strong>
      {shownTotal > 0 && (
        <>
          {' '}
          of <strong className={styles.value}>{shownTotal}</strong>
        </>
      )}{' '}
      results
    </span>
  )
}
